import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { colors } from "../../theme/palette";
import {
  ActionsCardArrowLeft,
  ActionsCardArrowRight,
  ArrangeIcon,
  ChatIcon,
  CompareIcon,
  PaymentIcon,
} from "../../assets/icons/MUI/DashboardIcons";
import APP_ROUTES from "../../routers/routeConstants";

const commonBoxStyles = {
  width: "calc(25% - 2.5px)",
  padding: "28px 19px",
  borderRadius: "16px",
  border: "1px solid #EAECF0",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  background: colors.White,
  justifyContent: "flex-start",
};

const commonIconWrapperStyles = {
  padding: "10px",
  borderRadius: "50%",
  background: colors.Gray50,
  width: "fit-content",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const commonButtonStyles = {
  width: "fit-content",
  gap: "10px",
  padding: "0",
  marginTop: "auto",
  "&:hover": {
    background: "transparent",
  },
};

const QuickActions = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        gap: "10px",
        display: "flex",
      }}
    >
      <Box sx={commonBoxStyles}>
        <Box sx={commonIconWrapperStyles}>
          <CompareIcon />
        </Box>
        <Typography variant="h4ExtraBold">{t("pages.dashboard.compareTalentsAndProfessionals")}</Typography>
        <Button
          variant="text-lg"
          endIcon={currentLanguage === "ar" ? <ActionsCardArrowLeft /> : <ActionsCardArrowRight />}
          sx={commonButtonStyles}
          onClick={() => navigate(APP_ROUTES.NETWORK)}
        >
          {t("pages.dashboard.compareNow")}
        </Button>
      </Box>

      <Box sx={commonBoxStyles}>
        <Box sx={commonIconWrapperStyles}>
          <ChatIcon />
        </Box>
        <Typography variant="h4ExtraBold">{t("pages.dashboard.startChatYourNetwork")}</Typography>
        <Button
          variant="text-lg"
          endIcon={currentLanguage === "ar" ? <ActionsCardArrowLeft /> : <ActionsCardArrowRight />}
          sx={commonButtonStyles}
          onClick={() => navigate(APP_ROUTES.CHAT)}
        >
          {t("pages.dashboard.chatList")}
        </Button>
      </Box>

      <Box sx={commonBoxStyles}>
        <Box sx={commonIconWrapperStyles}>
          <ArrangeIcon />
        </Box>
        <Typography variant="h4ExtraBold">{t("pages.dashboard.arrangeFootballEvent")}</Typography>
        <Button
          variant="text-lg"
          endIcon={currentLanguage === "ar" ? <ActionsCardArrowLeft /> : <ActionsCardArrowRight />}
          sx={commonButtonStyles}
          onClick={() => navigate(APP_ROUTES.EVENTS)}
        >
          {t("pages.events.eventList.createEvent")}
        </Button>
      </Box>

      {/* <Box sx={commonBoxStyles}>
        <Box sx={commonIconWrapperStyles}>
          <PaymentIcon />
        </Box>
        <Typography variant="h4ExtraBold" sx={{ color: colors.Green100, opacity: "0.55" }}>
          {t("pages.dashboard.managePayments")}
        </Typography>
        <Button disabled variant="text-lg" sx={commonButtonStyles}>
          {t("pages.dashboard.comingSoon")}
        </Button>
      </Box> */}
    </Box>
  );
};

export default QuickActions;
